import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React from 'react';
import Slider from 'react-slick';
import styles from './style.module.scss';
import Headline from '../Headline/index';
import '../../styles/_slick.scss';

/**
 * A component showing a slide of elements
 *
 * @param {React.Node}  children  The children slides
 **/
var VerticalSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(VerticalSelect, _React$Component);

  function VerticalSelect(props) {
    var _this;

    _classCallCheck(this, VerticalSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VerticalSelect).call(this, props));

    _this.setChildActive = function (index) {
      _this.setState({
        active: index
      });
    };

    _this.renderChildren = function () {
      return React.Children.map(_this.props.children, function (child, index) {
        return React.cloneElement(child, {
          active: _this.state.active === index,
          index: index,
          setActive: _this.setChildActive
        });
      });
    };

    _this.settings = {
      dots: false,
      arrows: true,
      infinite: false,
      rows: 3,
      slidesPerRow: 1,
      slidesToScroll: 1,
      slidesToShow: 1,
      vertical: true,
      focusOnSelect: true,
      className: styles.slider
    };
    _this.state = {
      active: 1
    };
    return _this;
  }
  /**
   * Callback to set a child as active
   *
   * @param {number}  index The index of the active child
   **/


  _createClass(VerticalSelect, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: styles.sliderWrapper
      }, React.createElement(Slider, this.settings, this.renderChildren()));
    }
  }]);

  return VerticalSelect;
}(React.Component);

/**
 * A select element
 *
 * @param {React.Node}  children  The children slides
 * @param {content}     subline   A subline for the slide element
 * @param {number}      index     The elements index
 * @param {boolean}     active    Wether or not the element is active
 * @param {void}        setActive Callback to set the element as active
 **/
var Element = function Element(_ref) {
  var index = _ref.index,
      children = _ref.children,
      subline = _ref.subline,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      setActive = _ref.setActive;
  return React.createElement("div", {
    className: "".concat(styles.wrapper, " ").concat(active && styles.active),
    onClick: function onClick() {
      return setActive(index);
    }
  }, React.createElement(Headline, {
    size: 3,
    center: true,
    pseudo: true,
    noMargin: true
  }, React.createElement("span", {
    className: styles.content
  }, children)), React.createElement("div", {
    className: styles.subline
  }, subline));
};

VerticalSelect.Element = Element;
export default VerticalSelect;